import ProjectLoader from "../../../../../core/manager/project/project-loader"
import ProjectViews from "../../../../../core/model2/project-view/project-views"
import {ViewType} from "../../../../../core/gd/const/views/view-type"
import {ProjectViewAccess} from "../../../../../core/model2/project-view/@const"
import ProjectView from "../../../../../core/model2/project-view/project-view"
import {ProjectViewConfig} from "../../../../../core/model2/project-view/@types"
import ApiProject from "../../../../../core/gd/api/project"
import Template from "../../../../../core/model2/template/template";

// const debug = "createProjectDashboardFromTemplate"
const debug = false

export async function createProjectDashboardFromTemplate(projectId: ID, template: Template, params?: any) {

    debug && console.log(debug, 'process [A]', projectId, Template, params)

    const dashboardName = params?.dashboardName || template.name
    const projectLoader = new ProjectLoader(projectId);

    await projectLoader.isLoaded

    debug && console.log(debug, 'process [B]', projectLoader.project, projectLoader)

    const projectViews = ProjectViews.initByProjectId(projectId)

    // const dashboardConfig : DashboardConfig = template.configFunction()

    if (params.parentProjectId) {
        // create view in structure
        const response = await ApiProject.newView({
            name            : dashboardName,
            color           : 1,
            parentProjectId : params.parentProjectId,
            projectIcon     : 'view-dashboard',
            templateId      : template.publicId,


        }).promise()
        gd.navigation.goToProject(response.projectId)
    } else {
        // create project view
        const projectViewConfig: ProjectViewConfig = {
            systemType      : ViewType.PROJECT_DASHBOARD,
            name            : dashboardName,
            access          : ProjectViewAccess.PUBLIC,
            templateId      : template.publicId,
        }

        const newProjectView : ProjectView = await projectViews.createView(projectViewConfig)

        // newProjectView.saveAppSettings(dashboardConfig)
        // await projectViews.save()

        gd.goTo(newProjectView.url)
    }
}